import { createContext } from 'react'
import { type Config, getConfig } from './config'

export const RUNTIME_CONFIG = getConfig()
export const ConfigContext = createContext<Config>(RUNTIME_CONFIG)
